import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';

export interface LenderState {
  lenders: [];
  dropdownFields: {};
  adminUserDetails: {};
  lenderSortingConfig: {};
  completeLendersData?: {};
  creditFetchingStatus: {};
  lenderErrors: {};
}

const initialState: LenderState = {
  lenders: [],
  dropdownFields: {},
  adminUserDetails: {},
  lenderSortingConfig: {},
  completeLendersData: {},
  creditFetchingStatus: {},
  lenderErrors: {},
};

export const lenderSlice = createSlice({
  name: 'lenders',
  initialState,
  reducers: {
    getLenders: (state, actions) => {},
    saveLenders: (state, action) => {
      state.lenders = get(action, 'payload.data.responses[0].lenders', []);
      state.completeLendersData = get(action, 'payload.data.responses[0]', {});
    },
    updateSortedLenders: (state, action) => {
      state.lenders = action.payload;
    },
    updateAdminUserDetails: (state, action) => {
      state.adminUserDetails = action.payload;
    },
    updateSortingConfig: (state, action) => {
      state.lenderSortingConfig = {
        ...state.lenderSortingConfig,
        ...action.payload,
      };
    },
    updateCreditFetchingStatus: (state, action) => {
      state.creditFetchingStatus = action.payload;
    },
    updateLenderError: (state, action) => {
      state.lenderErrors = action.payload;
    },
    resetLendersData: (state) => {
      state.lenders = [];
      state.adminUserDetails = {};
      state.dropdownFields = {};
      state.lenderSortingConfig = {};
      state.completeLendersData = {};
      state.creditFetchingStatus = {};
      state.lenderErrors = {};
    },
  },
});

export const {
  getLenders,
  saveLenders,
  updateSortedLenders,
  updateAdminUserDetails,
  updateSortingConfig,
  resetLendersData,
  updateCreditFetchingStatus,
  updateLenderError,
} = lenderSlice.actions;
export default lenderSlice.reducer;
